import produce from 'immer';
export var initialState = {
    loading: false,
    updating: false,
    error: false,
    status: {},
    statusOrg: '',
};
function orgStatusSummeryReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_STATUS_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_STATUS_SUCCESS':
                state.loading = false;
                state.error = false;
                state.status = action.status || [];
                state.statusOrg = action.orgId || '';
                break;
            case 'LOAD_STATUS_FAILURE':
                state.loading = false;
                state.error = true;
                state.status = {};
                break;
            case 'RESET_STATUS_SUMMERY':
                state.loading = false;
                state.error = false;
                state.status = {};
                break;
            default:
                break;
        }
    });
}
export default orgStatusSummeryReducer;
